package io.horion.cv.api.datasource.payement

import kotlinx.serialization.Serializable

@Serializable
data class PaymentRequest(
    val userUuid: String,
    val sessionsUuid: String,
    val serviceType: ServiceType,
    val amount: Double,
    val phoneNumber: String,
    val method: PaymentMethod
)
